"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isPath = void 0;
var symbol_1 = require("./symbol");
var isPath = function (path) { return path && path.__symbol__ === symbol_1.PathSymbol; };
exports.isPath = isPath;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaXNQYXRoLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL3BhdGgvaXNQYXRoLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUFBLG1DQUFzQztBQUUvQixJQUFNLE1BQU0sR0FBRyxVQUFDLElBQVMsSUFBSyxPQUFBLElBQUksSUFBSSxJQUFJLENBQUMsVUFBVSxLQUFLLG1CQUFVLEVBQXRDLENBQXNDLENBQUM7QUFBL0QsUUFBQSxNQUFNLFVBQXlEIn0=